module.exports = __webpack_public_path__ + "img/home.f744c6eb.jpg";